module.exports = __webpack_public_path__ + "large2.jpg?000c1c493639b472f713dd9b5ba95853";